import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import styles from "./PostLoad/postLoad.module.scss";
import invStyles from "./PostInventory/postInventory.module.scss";
import { timeZoneFun } from 'web/components/utils/timeZoneUtils';
import ReferenceNumberList from "web/components/ReferenceNumberList";
import { officeDaysArr } from './constants';
import { checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import Edit from "web/assets/images/edit.png";
import RightArrow from "web/assets/images/right-arrow-dark-blue.webp";
import SellArrow from "web/assets/images/right-arrow-sell.png";
import Select from "web/components/form-elements/Select";
import TextInput from "web/components/form-elements/TextInput";
import NumberInput from "web/components/form-elements/NumberInput";
import TimePickerInput from "web/components/form-elements/TimePickerInput";
import CheckboxInput from "web/components/form-elements/CheckboxInput";

const LocationDetails = ({ ...props }) => {
    const dispatch = useDispatch();
    let history = useHistory();
    const storedData = useSelector((state) => state.storedData.payload);

    const isBroker = localStorage.getItem('brokerAccount')
    const token = localStorage.getItem('token')

    // const [ptPlusOrderRequestEditFlag, setptPlusOrderRequestEditFlag] = useState(false)
    const locationsList = useSelector((state) => state.postLoad?.subLocationsList);
    const [editBrokerAddressFlag, setEditBrokerAddressFlag] = useState(true)
    const [locationsListArray, setLocationsListArray] = useState()
    useEffect(() => {
        const { setFieldValue } = props.formikProps
        if (locationsList && locationsList?.defaultLocationDetails) {
            let mainLocationsListTemp, subLocationsListTemp
            mainLocationsListTemp = [locationsList?.defaultLocationDetails]
            mainLocationsListTemp = mainLocationsListTemp.map(data => ({ label: data.locationName, value: data.locationName, otherData: data, locationType: 'main' }))
            if (locationsList.depLocationDetails && locationsList.depLocationDetails?.length > 0) {
                subLocationsListTemp = locationsList?.depLocationDetails.map(data => ({ label: data.locationName, value: data.locationName, otherData: data, locationType: 'sub' }))
            }
            let tempValue = []
            if (subLocationsListTemp) tempValue = [mainLocationsListTemp, subLocationsListTemp]
            else tempValue = [mainLocationsListTemp]
            tempValue = tempValue.flat()
            setLocationsListArray(tempValue)
            if(props?.postedNeedEditValues && tempValue){
                let locationTypeObject = tempValue.filter(val => val.label === props?.postedNeedEditValues?.shippingAddress?.locationName)
                if(locationTypeObject?.length) {
                    let editedNeedLocationType = locationTypeObject[0].locationType
                    setFieldValue('locationType', editedNeedLocationType)
                }
            }
            if (!props?.postedNeedEditValues && !props?.postedNeedEditValues?.postTitle && !props?.urlObject?.postType && !props?.urlObject?.id && !props?.urlObject?.ptplusAdminPost) {

                setFieldValue("locationId", tempValue[0].otherData?.locationId);
                setFieldValue("shipperName", tempValue[0].otherData?.locationName);
                setFieldValue("line1", tempValue[0].otherData?.address?.address1);
                setFieldValue("line2", tempValue[0].otherData?.address?.address2);              
                setFieldValue("state", tempValue[0].otherData?.address?.state);
                setFieldValue("city", tempValue[0].otherData?.address?.city);
                setFieldValue("zip", tempValue[0].otherData?.address?.zipCode); 
                
                setFieldValue("brokerOperationDays", tempValue[0].otherData?.address?.locationDaysOfOperations);
                setFieldValue("brokerOperationStartTime", tempValue[0].otherData?.address?.locationOfficeHourStart);
                setFieldValue("brokerOperationEndTime", tempValue[0].otherData?.address?.locationOfficeHourEnd);
                setBidCloseTime(tempValue[0].otherData?.address?.state)

                if (props.page === 'createNeed') {
                    setFieldValue("appt", tempValue[0].otherData?.address?.locationOfficeHourStart);
                    setFieldValue("postLoadDeliveryWindowBegin", tempValue[0].otherData?.address?.locationOfficeHourStart);
                    setFieldValue("postLoadDeliveryWindowEnd", tempValue[0].otherData?.address?.locationOfficeHourEnd);
                }

                if (locationsList?.defaultLocationDetails?.userPreferences) {
                    if (locationsList?.defaultLocationDetails?.userPreferences?.vehiclePreferences?.length > 0) {
                        setFieldValue('noteRadio0', false)
                        setFieldValue('noteRadio1', false)
                        setFieldValue('noteRadio2', false)
                        setFieldValue('vehiclePreferences0', false)
                        setFieldValue('vehiclePreferences1', false)
                        setFieldValue('vehiclePreferences2', false)
                        
                        if (locationsList?.defaultLocationDetails?.userPreferences?.vehiclePreferences?.includes('FLAT_BED')) {
                            if (props.page === 'createNeed') setFieldValue('noteRadio0', true)
                            else setFieldValue('vehiclePreferences0', true)
                        }
                        if (locationsList?.defaultLocationDetails?.userPreferences?.vehiclePreferences?.includes('VAN')) {
                            if (props.page === 'createNeed') setFieldValue('noteRadio1', true)
                            else setFieldValue('vehiclePreferences1', true)
                        }
                        if (locationsList?.defaultLocationDetails?.userPreferences?.vehiclePreferences?.includes('NO_PREFERENCES')) {
                            if (props.page === 'createNeed') setFieldValue('noteRadio2', true)
                            else setFieldValue('vehiclePreferences2', true)
                        }
                    }
                    if (locationsList?.defaultLocationDetails?.userPreferences?.dropLive) {
                        if (props.page === 'createNeed' && locationsList?.defaultLocationDetails?.userPreferences?.dropLive === 'DROP') {
                            setFieldValue('dropLive', 'DROP')
                        } else if (props.page === 'createNeed' && locationsList?.defaultLocationDetails?.userPreferences?.dropLive === 'LIVE') {
                            setFieldValue('dropLive', 'LIVE')
                        }
                    }
                }
                
                // const intervalCall = setInterval(() => {
                //     if(!props?.postedNeedEditValues)
                //     setFieldValue("state", tempValue[0].otherData?.address?.state);
                //     setFieldValue("city", tempValue[0].otherData?.address?.city);
                //     setFieldValue("zip", tempValue[0].otherData?.address?.zipCode);                
                //   }, 3000);
                // return () => clearInterval(intervalCall)
            } else {
                if (props.postedNeedEditValues) {
                    // setFieldValue("brokerOperationDays", tempValue[0].otherData?.address?.locationDaysOfOperations);
                    // setFieldValue("brokerOperationStartTime", tempValue[0].otherData?.address?.locationOfficeHourStart);
                    // setFieldValue("brokerOperationEndTime", tempValue[0].otherData?.address?.locationOfficeHourEnd);
                    setFieldValue("brokerOperationDays", (props.postedNeedEditValues?.shippingAddress?.locationDaysOfOperations || tempValue[0].otherData?.address?.locationDaysOfOperations));
                    setFieldValue("brokerOperationStartTime", (props.postedNeedEditValues?.shippingAddress?.locationOfficeHourStart || tempValue[0].otherData?.address?.locationOfficeHourStart));
                    setFieldValue("brokerOperationEndTime", (props.postedNeedEditValues?.shippingAddress?.locationOfficeHourEnd || tempValue[0].otherData?.address?.locationOfficeHourEnd));
                }
            }
        }
    }, [locationsList, props.postedNeedEditValues])

    useEffect(() => {
        const { setFieldValue } = props.formikProps
        if (props.postedNeedEditValues && !props.appointmentEndTime) {
            setTimeout(() => {
                // during edit post need case, if appointment to time is null, then location's default end time should be set
                let locationEndTimeValue = locationsList?.defaultLocationDetails?.address?.locationOfficeHourEnd
                setFieldValue("postLoadDeliveryWindowEnd", locationEndTimeValue);
            }, 100)
        }
    }, [locationsList, props.postedNeedEditValues])

    const setBidCloseTime = (state) => {
        const { setFieldValue } = props.formikProps
        // state zone assign based in selected state
        let stateZone, bidCloseTime
        if (state === 'California') stateZone = 'America/Los_Angeles'
        else if (state === 'Alaska') stateZone = 'US/Alaska'
        else if (state === 'American Samoa') stateZone = 'American/American Samoa'
        else if (state === 'Washington') stateZone = 'America/Washington'

        const moment = require('moment-timezone');
        if (stateZone) bidCloseTime = moment().tz(stateZone).format('HH:mm');
        else {
            let tempTime = new Date().toLocaleString('en-US', { timeZone: 'US/' + timeZoneFun(state) });
            let getTime = new Date(tempTime)
           
            let setHours = getTime.getHours()
            let setMinutes = getTime.getMinutes()
            if (setHours.toString().length === 1) setHours = '0' + setHours
            if (setMinutes.toString().length === 1) setMinutes = '0' + setMinutes
            bidCloseTime = setHours + ':' + setMinutes

            if(!props.postedNeedEditValues && !props?.postedNeedEditValues?.postTitle && !props?.urlObject?.postType && !props?.urlObject?.id && !props?.urlObject?.ptplusAdminPost)
            setFieldValue('bidCloseTime', new Date(new Date().setDate(new Date(getTime).getDate() + 1)).toLocaleDateString('en-US'))
        }

        
        setFieldValue('postLoadBidCloseTime', bidCloseTime)
    }

    const zipCodeHandler = async (value, props) => {
        const { setFieldValue, values } = props
        let formikValues = values
        setFieldValue('errorFields', formikValues.errorFields?.filter(data => data !== 'zipCode'))

        let response = '';
        if (value.length === 5) {
            response = await dispatch(checkIsZipCode(value, token))
            if (response.success) {
                if (response?.data?.city) setFieldValue('city', response?.data?.city)
                setFieldValue('zip', response?.data?.zipCode)
                setFieldValue('state', response?.data?.state)
                setBidCloseTime(response?.data?.state)
            } else {
                if (response?.data?.error?.message === 'Invalid Zip Code.') {
                    let prevValues = formikValues.errorFields
                    prevValues.push('zipCode')
                    setFieldValue('city', "")
                    setFieldValue('state', "")
                    setFieldValue('errorFields', prevValues)
                } else if (response.error?.message === "Invalid token" || response.message === 'Request failed with status code 401') {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {
                }
            }
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [addressState, setAddressState] = useState(true);

    return (
        <>
            <HeadingWrapper className="mb-3">
                <h6 className={props.page === 'createNeed' ? styles.headingName : invStyles.headingName}>
                    {props?.pageLanguageContents?.Arrow_MyLocation[0]?.Title}
                    {isBroker === 'brokerAc' && editBrokerAddressFlag && <img
                        className="ml-2"
                        style={{ cursor: "pointer", width: "25px" }}
                        onClick={() => setEditBrokerAddressFlag(false)}
                        src={Edit}
                        alt="edit"
                    />}
                </h6>
                <img
                    src={props.page === 'createNeed' ? RightArrow : SellArrow}
                    alt="RightArrow"
                    className="right-arrow"
                />
            </HeadingWrapper>
            <div>
                <div className="row">
                    <div className="col-md-6 mb-7" name="Company Name">
                        <p className="mt-0" >Company Name</p>
                        {/* {isBroker}------{locationsList?.length} */}
                        {(isBroker === 'brokerAc' || (locationsList?.length === 1) || locationsListArray?.length === 1) || props?.postedNeedEditValues ?
                            <TextInput
                                name="shipperName"
                                placeholder="Company Name"
                                inputType="companyText"
                                disabled={editBrokerAddressFlag}
                                showErrorMessages={true}
                            /> :
                            <Select
                                name="shipperName"
                                data={locationsListArray || []}
                                placeholder="Name"
                                onChangeHandler={(data) => {
                                    props.formikProps.setFieldValue("locationId", data.otherData?.locationId);
                                    props.formikProps.setFieldValue("line1", data.otherData?.address?.address1);
                                    props.formikProps.setFieldValue("line2", data.otherData?.address?.address2);
                                    props.formikProps.setFieldValue("state", data.otherData?.address?.state);
                                    props.formikProps.setFieldValue("city", data.otherData?.address?.city);
                                    props.formikProps.setFieldValue("zip", data.otherData?.address?.zipCode);
                                    props.formikProps.setFieldValue("locationType", data.locationType);
                                    // localStorage.setItem('location', data.locationType)
                                    if (data.locationType === 'sub') props.formikProps.setFieldValue("postingPlacePreference", 'MARKET')
                                    setBidCloseTime(data.otherData?.address?.state)
                                }}
                            />
                        }
                    </div>

                    {(storedData?.data?.isEnablePtPlusFeature
                      && props.page === 'createNeed') && <div className="col-sm-6">
                        <label className="form-label">
                            Order Reference Number
                        </label>

                        {editBrokerAddressFlag && isBroker === 'brokerAc' ? <TextInput
                            name="referenceNumber"
                            placeholder="Reference Number"
                            inputType="companyText"
                            disabled={addressState}
                            showErrorMessages={true}
                        /> :

                            <ReferenceNumberList disabled={props?.orderRefNumberDisableState} editResponse={props?.postedNeedEditValues} callback={(refNumber) => {
                            }} />}
                    </div>}

                </div>
                <div className="row  ">
                    <div className="col-md-6 mb-7">
                        <p className="mt-0">{props?.pageLanguageContents?.Arrow_MyLocation[1]?.Add1}<span className={styles.star}>&#42;</span></p>
                        <TextInput
                            name="line1"
                            placeholder="Street Address 1"
                            disabled={editBrokerAddressFlag}
                            showErrorMessages={true}
                        />
                    </div>
                    <div className="col-md-6 mb-7">
                        <p className="mt-0">{props?.pageLanguageContents?.Arrow_MyLocation[2]?.Add2}</p>
                        <TextInput
                            name="line2"
                            placeholder={props?.pageLanguageContents?.Arrow_MyLocation[3]?.Add2_Placeholder}
                            showErrorMessages={true}
                            disabled={editBrokerAddressFlag}
                        />
                    </div>
                </div>
                <div className="row mb-2">
                    {/*  select-height */}
                    <div className="col-md-4 mb-7 col-sm-6" style={{marginBottom : (isBroker !== 'brokerAc' ? '32px' : '7px')}}>
                        <p className="mt-0">
                            {props?.pageLanguageContents?.Arrow_MyLocation[5]?.City}<span className={styles.star}>&#42;</span>
                        </p>
                        <TextInput
                            name="city"
                            placeholder="City"
                            showErrorMessages={true}
                            disabled={editBrokerAddressFlag}
                        />
                    </div>
                    {/* select-height */}
                    <div className="col-md-4 mb-7">
                        <p className="mt-0">
                            {props?.pageLanguageContents?.Arrow_MyLocation[4]?.State}<span className={styles.star}>&#42;</span>
                        </p>
                        <TextInput name="state" disabled={true} />
                    </div>
                    {/*  select-height */}
                    <div className="col-md-4 mb-7 col-sm-6">
                        <p className="mt-0">Zip Code<span className={styles.star}>&#42;</span></p>
                        <NumberInput
                            name="zip"
                            placeholder="Zip"
                            disabled={editBrokerAddressFlag}
                            showErrorMessages={true}
                            onChangeHandler={(value) => (isBroker === 'brokerAc' && !editBrokerAddressFlag) && zipCodeHandler(value, props.formikProps)}
                        />
                        {/* {props.formikProps?.values?.errorFields?.length > 0 && props.formikProps?.values?.errorFields?.includes('zipCode') && <p style={{ position: 'absolute', bottom: '-2px', fontSize: '12px', color: '#ef5657 ' }}>Invalid Zip Code.</p>} */}
                        {props.formikProps?.values?.errorFields?.length > 0 && props.formikProps?.values?.errorFields?.includes('zipCode') && <p style={{fontSize: '12px', color: '#ef5657 ',margin: "0px" }}>Invalid Zip Code.</p>}
                    </div>
                </div>

                {isBroker === 'brokerAc' && <>
                    <div className="row">
                        <div className="mb-3">
                            <div className="col-sm-12">
                                <label className="form-label">
                                    Location’s Days of Operation
                                </label>
                                <div
                                    className={`${styles.subHeading} ${styles.bdrBtm} ${styles.daysCheckBox} mt-0 office-days`}
                                >
                                    {officeDaysArr.map((value, i) => (
                                        <CheckboxInput
                                            name={value}
                                            label={value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()}
                                            handleSelect={(value, label, checked) => {
                                                let tempValue = props.formikProps?.values?.brokerOperationDays?.filter(data => data !== label.toUpperCase())
                                                if (checked) tempValue.push(label.toUpperCase())
                                                const { setFieldValue } = props.formikProps
                                                setFieldValue('brokerOperationDays', tempValue)
                                            }}
                                            checked={props.formikProps?.values?.brokerOperationDays?.includes(value) ? true : false}
                                            disabled={editBrokerAddressFlag}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div style={{marginBottom: '32px'}}>
                            <div className="col-sm-12">
                                <label className="form-label">
                                    Location’s Hours of Operation
                                </label>
                                <div
                                    className={`${styles.subHeading} ${styles.bdrBtm} w-100`}
                                >
                                    <DateTimeWrapper className={`${styles.dateAndTime} row`}>
                                        <div className="col-md-4 col-5">
                                            <TimePickerInput
                                                name="brokerOperationStartTime"
                                                type="createPost"
                                                disabled={editBrokerAddressFlag}
                                                selectedValue={props.formikProps?.values?.brokerOperationStartTime}
                                                showErrorMessages={true}
                                            />
                                        </div>
                                        <span className={styles.toStyle}>
                                            To
                                        </span>
                                        <div className="col-md-4 col-5">
                                            <TimePickerInput
                                                name="brokerOperationEndTime"
                                                type="createPost"
                                                disabled={editBrokerAddressFlag}
                                                selectedValue={props.formikProps?.values?.brokerOperationEndTime}
                                                showErrorMessages={true}
                                            />
                                        </div>
                                    </DateTimeWrapper>
                                </div>
                            </div>
                        </div>
                    </div>

                </>
                }
            </div>
        </>
    )
}

export default LocationDetails;

const HeadingWrapper = styled.div`
  position: relative;
  .right-arrow {
    position: absolute;
    left: -33px;
    top: 0;
  }
  @media (max-width: 767px) {
    h6 {
      font-size: 20px !important;
      line-height: 36px !important;
      padding-left: 48px !important;
    }
    .right-arrow {
      max-width: 71px;
    }
  }
`;
const DateTimeWrapper = styled.div`
  .custom-date-piker {
    display: block;
    .app-input-text {
      margin-bottom: 0;
    }
  }
`;
